import { PLANNER_INDEX, PLANNER_LOADING } from '../actions/planner'
import apiCall from '../../utils/api'
import store from '../index'

const state = {
  all: []
}

const getters = {
  [PLANNER_INDEX]: (state, getters) => {
    return state.all
  },
  [PLANNER_LOADING]: (state) => {
    return !state.all.length
  }
}

const actions = {
  [PLANNER_INDEX]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      apiCall({url: 'api/planner', method: 'GET'})
        .then(resp => {
          let user = resp.find((user, i) => {
            if (user.id === store.state.user.profile.id) {
              resp.splice(i, 1)
              return true
            }
          })
          resp.sort((a, b) => {
            if (a.name.toUpperCase() < b.name.toUpperCase()) {
              return -1
            }
            if (a.name.toUpperCase() > b.name.toUpperCase()) {
              return 1
            }
            return 0
          })
          resp.unshift(user)

          commit(PLANNER_INDEX, resp)
        })
      resolve()
    })
  }
}

const mutations = {
  [PLANNER_INDEX]: (state, resp) => {
    state.all = resp
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/planner.js